import { render } from "./WelcomeToTheConferenceView.vue?vue&type=template&id=44bcd678&scoped=true"
import script from "./WelcomeToTheConferenceView.vue?vue&type=script&lang=js"
export * from "./WelcomeToTheConferenceView.vue?vue&type=script&lang=js"

import "./WelcomeToTheConferenceView.vue?vue&type=style&index=0&id=44bcd678&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-44bcd678"]])

export default __exports__